import { graphql, useFragment } from "react-relay";
import { TopicLinkFragment$key } from "./__generated__/TopicLinkFragment.graphql";
import { LinkProps } from "react-router";
import { Link } from "react-router";
import { getTopicPath, PathSegment } from "../utils/routing";
import { useContext } from "react";
import { TopicVotableOrderContext } from "../utils/votableOrder";

const TopicLinkFragment = graphql`
  fragment TopicLinkFragment on Topic {
    id
    title
    forum {
      slug
      owner {
        slug
        forumOwnerKind
      }
    }
  }
`;

export interface TopicLinkProps extends Omit<LinkProps, "to"> {
  topic: TopicLinkFragment$key;
  parent?: PathSegment;
  subpath?: string | undefined;
}

export default function TopicLink({
  topic: topicFragment,
  parent,
  subpath,
  ...props
}: TopicLinkProps) {
  const topic = useFragment(TopicLinkFragment, topicFragment);
  const order = useContext(TopicVotableOrderContext);
  const topicWithParent = {
    ...topic,
    forum: {
      ...topic.forum,
      owner: {
        ...topic.forum.owner,
        parent,
      },
    },
  };
  return (
    <Link
      {...props}
      to={
        subpath
          ? getTopicPath(topicWithParent, subpath)
          : getTopicPath(topicWithParent)
      }
      state={{ order }}
      rel="canonical"
    />
  );
}
